import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { SearchEnrollmentDto } from "../repositories/search/dto/search-enrollment.dto";

@Injectable({
    providedIn: 'root'
})
export class SearchState { // I call this file a 'state' instead of a service because it does not get injected the same way
    // don't use any there should be a valid type. I'm initializing my any type to null for this example but IRL I wouldn't do that unless it makes sense.
    private readonly _value = new BehaviorSubject<SearchEnrollmentDto>(null);
    // a behavior subject is a subject that starts with an initial value and will emit any changes to that value instantly to any component hooked to it. it's the easiest one to use.
    public readonly $value = this._value.asObservable();

    // this is a getter so you can get a 1 time view of what it is set to (right now it's null)
    public get value$() {
        return this._value.getValue();
    }

    // this allow you to change or mutate your observable and emit that change to your subscribers
    public set value$(val: SearchEnrollmentDto) {
        this._value.next(val);
    }
}